module.exports = __webpack_public_path__ + "assets/img/img321.35ef0b2f.png";